import { FunctionComponent, PropsWithChildren, ReactElement } from 'react';

import { FormControl, InputLabel } from '@mui/material';

import BaseSelectWithCheckboxes from '../../../../../../shared/components/base-select-with-checkboxes/base-select-with-checkboxes';
import { useSelectWithCheckboxesOnChange } from '../../../../../../shared/components/base-select-with-checkboxes/hooks/use-select-with-checkboxes-on-change/use-select-with-checkboxes-on-change.hook';
import { WithOptionsModel } from '../../../../../../shared/components/with-options/models/with-options.model';
import withPlatformOptions from '../../../../../../shared/components/with-platform-options/with-platform-options';
import { FirmwareFilters } from '../../../../models/firmware-filters.model';
import { filterFirmwaresByPlatform } from '../../../../store/slices/firmware.slice';
import { FirmwareFilterProps } from '../../types/firmware-filter-props.type';
import { withFirmwareFilterValues } from '../with-firmware-filters-values/with-firmware-filters-values';

const PlatformsDropdown: FunctionComponent<
  FirmwareFilterProps & WithOptionsModel
> = (
  props: PropsWithChildren<FirmwareFilterProps & WithOptionsModel>
): ReactElement => {
  const {
    options,
    setFieldValue,
    firmwareSelectFilters: { platformIds: selectedPlatformIds },
  } = props;

  const selectedPlatformsMapped = options
    .filter(item => selectedPlatformIds?.includes(item.id))
    .map(item => item.id);

  const onChange = useSelectWithCheckboxesOnChange<FirmwareFilters>(
    'platformIds',
    setFieldValue,
    filterFirmwaresByPlatform
  );

  return (
    <FormControl
      classes={{
        root: 'form-control-main',
      }}
      key="apps-platforms"
      variant="filled"
    >
      <InputLabel id="multiple-checkbox-label-platforms">Platforms</InputLabel>

      <BaseSelectWithCheckboxes
        id="platforms"
        name="platforms"
        onChange={onChange}
        selectOptions={options}
        clearMultiSelectFilterAction={filterFirmwaresByPlatform}
        value={selectedPlatformsMapped ?? []}
      />
    </FormControl>
  );
};

export default withFirmwareFilterValues(withPlatformOptions(PlatformsDropdown));
